import { PacketIn } from "./PacketIn.js";
import { InboundPacketType } from "./InboundPacketType.js";
import type { MessageIOContext } from "../../../api/MessageIOContext.js";
import { readJsonString, readNullableJsonInt } from "../../../../util/json.js";
import { ReactionType } from "../../ReactionType.js";


export class PacketInReaction extends PacketIn {
    public playerNo: number | null = null;
    public reaction: ReactionType | null = null;

    constructor() {
        super(InboundPacketType.REACTION);
    }

    override readContents(_context: MessageIOContext, json: Record<string, any>): void {
        this.playerNo = readNullableJsonInt(json, "player_no");
        this.reaction = ReactionType.getByID(readJsonString(json, "reaction_id"));
    }
}
